import { createContext, useContext, useState } from "react";
import { getToken, logout as logoutService } from "../services/authService";

type AuthContextType = {
  token: string | null;
  isAuthenticated: boolean;
  login: (jwt: string) => void;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children } :any) {
  const [token, setToken] = useState(getToken());

  const login = (jwt: string) => {
    setToken(jwt);
  };

  const logout = () => {
    logoutService();
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside an AuthProvider");
  return ctx;
}